import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { RefrigerantsActions } from './refrigerants.actions';
import { RefrigerantService } from '../../services/refrigerant.service';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable()
export class RefrigerantsEffects {
  private actions$ = inject(Actions);
  private refrigerantService = inject(RefrigerantService);

  loadRefrigerants$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RefrigerantsActions.loadRefrigerants),
      switchMap(() =>
        this.refrigerantService.getAll().pipe(
          map(refrigerants => RefrigerantsActions.loadRefrigerantsSuccess({ refrigerants })),
          catchError(error => of(RefrigerantsActions.loadRefrigerantsFailure({ error: error.message })))
        )
      )
    )
  );

  createRefrigerant$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RefrigerantsActions.createRefrigerant),
      mergeMap(({ refrigerant }) =>
        this.refrigerantService.create(refrigerant).pipe(
          map(created => RefrigerantsActions.createRefrigerantSuccess({ refrigerant: created })),
          catchError(error => of(RefrigerantsActions.createRefrigerantFailure({ error: error.message })))
        )
      )
    )
  );

  updateRefrigerant$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RefrigerantsActions.updateRefrigerant),
      mergeMap(({ id, refrigerant }) =>
        this.refrigerantService.update(id, refrigerant).pipe(
          map(updated => RefrigerantsActions.updateRefrigerantSuccess({ refrigerant: updated })),
          catchError(error => of(RefrigerantsActions.updateRefrigerantFailure({ error: error.message })))
        )
      )
    )
  );

  deleteRefrigerant$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RefrigerantsActions.deleteRefrigerant),
      mergeMap(({ id }) =>
        this.refrigerantService.delete(id).pipe(
          map(() => RefrigerantsActions.deleteRefrigerantSuccess({ id })),
          catchError(error => of(RefrigerantsActions.deleteRefrigerantFailure({ error: error.message })))
        )
      )
    )
  );
}
